import {
  Navigate,
  Outlet,
  RouteObject,
  createBrowserRouter,
  useLocation,
} from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import routeConstants from '../shared/constants/Routes';
import ErrorBoundary from '../components/common/ErrorBoundary';

const ProtectedRoutes = () => {
  const location = useLocation();
  const sessionStorageToken = sessionStorage.getItem('token');

  return sessionStorageToken ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
};

const routes: RouteObject[] = [
  {
    element: (
      <MainLayout>
        <Outlet />
      </MainLayout>
    ),
    children: [
      ...Object.values(routeConstants)
        .filter((route) => !route.auth)
        .map((route) => {
          return {
            index: route.index,
            path: route.path,
            element: route.element,
          };
        }),
      {
        element: <ProtectedRoutes />,
        children: Object.values(routeConstants)
          .filter((route) => route.auth)
          .map((route) => ({
            path: route.path,
            element: route.element,
          })),
      },
    ],
    errorElement: <ErrorBoundary />,
  },
];

export default createBrowserRouter(routes);
